import ManageKeyFeatures from './ManageKeyFeatures.component';

export default ManageKeyFeatures;
